import { ClienteModel } from 'app/model/cliente/cliente.model';
import { ProdutoModel } from './../../model/produto/produto.model';
import { Observable } from 'rxjs/Observable';
import { ResponsePageable } from './../../model/cliente/pageable/responsePageable.model';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from './../../../environments/environment.prod';
import { Injectable } from '@angular/core';

@Injectable()
export class ProdutoService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  getPageProduto(page, size): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + `/view/listar-produtos?page=${page}&size=${size}`, this.httpOptions);
  }

  getPageProdutoInativo(page, size): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + `/view/listar-produtos-inativos?page=${page}&size=${size}`, this.httpOptions);
  }

  getProduto(): Observable<ResponsePageable>{
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-produtos', this.httpOptions);
  }

  postProduto(grupoProduto: ProdutoModel): Observable<ProdutoModel>{
    return this.httpClient.post<ProdutoModel>(this.apiURL + '/new/adicionar-produto', grupoProduto, this.httpOptions);
  }

  postProdutoWithPreco(grupoProduto: ProdutoModel): Observable<ProdutoModel>{
    return this.httpClient.post<ProdutoModel>(this.apiURL + '/new/add-produto-preco', grupoProduto, this.httpOptions);
  }

  putProduto(grupoProduto: ProdutoModel): Observable<ProdutoModel>{
    return this.httpClient.put<ProdutoModel>(this.apiURL + '/edit/editar-produto', grupoProduto,  this.httpOptions);
  }

  deleteProduto(cod: any){
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.get(this.apiURL + '/delete/apagar-produto/' + cod, { responseType: 'text', headers });
  }

  getProdutoUnico(cod: any): Observable<ProdutoModel> {
    return this.httpClient.get<ProdutoModel>(this.apiURL + '/view/listar-produto/' + cod, this.httpOptions);
  }

  inativarProduto(id: any){
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'))

    return this.httpClient.get(this.apiURL + '/delete/inativar-produto/' + id, { responseType: 'text', headers });
  }

  ativarProduto(id: any){
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'))

    return this.httpClient.get(this.apiURL + '/delete/ativar-produto/' + id, { responseType: 'text', headers });
  }

  adicionarProduto(produto: ProdutoModel,id: any): Observable<ProdutoModel>{
    return this.httpClient.post<ProdutoModel>(this.apiURL + '/new/add-produto-cliente/' + id, produto, this.httpOptions);
  }

  removerProduto(produto: ProdutoModel, idCliente: any){
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'))

    return this.httpClient.post(this.apiURL + '/delete/remover-produto/' + idCliente, produto, { responseType: 'text', headers });
  }

  listarProtudosPorCliente(id: any): Observable<any> {
    return this.httpClient.get<any>(this.apiURL + '/view/' + id + '/clientes', this.httpOptions);
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/produto/produto.service.ts